import './promo-link.scss';
